import { useRouter } from 'next/router';
import type { GetServerSideProps, NextPage } from 'next/types';

import { Dashboard } from 'components/templates';
import { useEffectOnce } from 'hooks';
import { trackPageView } from 'modules/analytics';

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.setHeader(
    'Cache-Control',
    'no-cache, no-store, max-age=0, must-revalidate'
  );

  return {
    props: {},
  };
};

const DashboardPage: NextPage = () => {
  const router = useRouter();

  useEffectOnce(() => {
    trackPageView(router, {
      title: 'Overview',
    });
  });

  return <Dashboard />;
};

export default DashboardPage;
